
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// import { AutocompleteDataService } from '@app/services/autocomplete.service';

import { ServiceBase } from '@app/services/base.service';
import { EstadoCivil } from '@app/models/util/estado-civil';
import { Participante, ParticipanteListaFiltros } from '@app/models/participante.model';
import { ParticipanteOcorrencias } from '@app/models/participante-ocorrencias.model';



@Injectable()
export class ParticipanteService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(participante: Participante): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'cadastros/participante', participante).pipe(
        catchError(
          (error: any) => observableThrowError(error)
        )
      );
  }


  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `cadastros/participante/${id}`);
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `cadastros/participante/${id}`);
  }

  obterLista(pesquisa: ParticipanteListaFiltros, pagina: number): Observable<any> {
    return this.http.post<any>(
        this.URL_API + `cadastros/participante/lista?pagina=${pagina}`,
        pesquisa 
    );
}


  obterAutoComplete(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'cadastros/participante/ObterAutoComplete');
  }

  // obterPorTermo(tipoParticipante: string): Observable<any> {
  //   return new AutocompleteDataService(this.http, this.URL_API + `cadastros/participante/ObterAutoComplete/${tipoParticipante}`);
  // }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'cadastros/participante');
  }
  obterParceiros(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'cadastros/participante/parceiros');
  }
  obterAdvogadosParceiros(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'cadastros/participante/advogadosParceiros');
  }

  obterListaEstadoCivil() {
    const lstEstadoCivil = new Array<EstadoCivil>();
    lstEstadoCivil.push(new EstadoCivil('SOLTEIRO', 'Solteiro', 'Solteira'));
    lstEstadoCivil.push(new EstadoCivil('CASADO', 'Casado', 'Casada'));
    lstEstadoCivil.push(new EstadoCivil('DIVORCIDO', 'Divorciado', 'Divorciada'));
    lstEstadoCivil.push(new EstadoCivil('SEPARADO', 'Separado', 'Separada'));
    lstEstadoCivil.push(new EstadoCivil('VIUVO', 'Viúvo', 'Viúva'));
    lstEstadoCivil.push(new EstadoCivil('UNIAO ESTAVEL', 'União Estável'));
    lstEstadoCivil.push(new EstadoCivil('DESQUITADO', 'Desquitado', 'Desquitada'));
    lstEstadoCivil.push(new EstadoCivil('CONVIVENTE', 'Convivente'));
    lstEstadoCivil.push(new EstadoCivil('OUTRO', 'Outro'));
    return lstEstadoCivil;
  }

obterPermissoesUsuarioTipo(usuarioTipoId: number): Observable<any> {
  return this.http
  .get<any>(`${this.URL_API}cadastros/funcionario/obterUsuarioTipoPermissoes/?usuarioTipoId=${usuarioTipoId}`)
}

  verificaPermissaoUsuario(usuarioId: number, permissao: string): Observable<any> {
    return this.http
      .get<any>(this.URL_CACHE + `cadastros/funcionario/verificaPermissaoUsuario/?usuarioId=${usuarioId}&permissao=${permissao}`).pipe(
        catchError((error) => {
            if(error.status === 400){
              return observableThrowError(error.json);
            }
            return this.http.get<any>(this.URL_API + `cadastros/funcionario/verificaPermissaoUsuario/?usuarioId=${usuarioId}&permissao=${permissao}`).pipe(
                      catchError((error: any) => observableThrowError(error.json)))
        }));
  }

  alterarFoto(participanteId: number, formData: FormData): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `cadastros/participante/alterarFoto/${participanteId}`,
        formData, { headers: { meta: ['upload'] } }
      ).pipe(
        catchError((error: any) => observableThrowError(error.json()))
      );
  }

  verificarDocumentoCadastrado(documento: string) {
    return this.http
      .get<ParticipanteOcorrencias[]>(
        this.URL_API + `cadastros/participante/verificarDocumentoCadastrado?documento=${documento}`
      );
  }

}
